import React, { useState } from "react";
import Styles from "./Element.module.css";
import { useDispatch, useSelector } from "react-redux";
import SelectInput from "../../../../commons/Inputs/Select/SelectInput";
import { Add } from "@mui/icons-material";
import {
  publicDiscomByStateId,
  publicStateByRegionId,
} from "../../../../Redux/Slices/publicSlice";
import { ReactComponent as RemoveIcon } from "../../../../assets/images/Remove.svg";

const DiscomDetails = ({ userData, handleData, handleProceed }) => {
  const publicData = useSelector((state) => state?.publicSlice);
  const dispatch = useDispatch();
  const [errors, setErrors] = useState("");
  const [discomDetails, setDiscomDetails] = useState(() => {
    if (userData?.discomDetails?.length > 0) {
      return userData.discomDetails;
    }
    return [createEmptyDiscomDetail()];
  });

  const [totalLength, setTotalLength] = useState(() => {
    if (userData?.discomDetails?.length > 0) {
      return new Array(userData.discomDetails.length).fill("Discom Details");
    }
    return ["Discom Details"];
  });

  function createEmptyDiscomDetail() {
    return {
      region: userData?.region || {},
      state: userData?.state || {},
      discom: userData?.discom || {},
    };
  }

  const validateFields = () => {
    const discomErrors = {};
    discomDetails.forEach((detail, index) => {
      const requiredFields = ["region", "state", "discom"];
      requiredFields.forEach((field) => {
        const fieldValue = detail[field];

        const isValid =
          fieldValue &&
          (fieldValue.id ||
            fieldValue.value ||
            (typeof fieldValue === "string" && fieldValue.trim() !== "") ||
            typeof fieldValue === "number" ||
            (typeof fieldValue === "object" &&
              Object.keys(fieldValue).length > 0 &&
              (fieldValue.name || fieldValue.acronym)));

        if (!isValid) {
          discomErrors[`${field}_${index}`] = `${field
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase())} is required`;
        }
      });
    });
    setErrors(discomErrors);
    return Object.keys(discomErrors).length === 0;
  };

  const handleFieldChange = (index, type, value, fetchFunction) => {
    const updatedDiscomDetails = [...discomDetails];
    updatedDiscomDetails[index][type] = value;

    if (type === "region") {
      updatedDiscomDetails[index].state = {};
      updatedDiscomDetails[index].discom = {};
    } else if (type === "state") {
      updatedDiscomDetails[index].discom = {};
    }

    if (fetchFunction && value?.id) {
      fetchFunction(value.id);
    }

    setDiscomDetails(updatedDiscomDetails);
    clearError(index, type);
  };

  const clearError = (index, type) => {
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[`${type}_${index}`];
      if (type === "region") {
        delete newErrors[`state_${index}`];
        delete newErrors[`discom_${index}`];
      } else if (type === "state") {
        delete newErrors[`discom_${index}`];
      }
      return newErrors;
    });
  };

  const handleContinue = (data) => {
    if (!validateFields()) return;
    handleData("discomDetails", discomDetails);
    handleProceed(data);
  };

  const handleAddUser = () => {
    setTotalLength((prev) => [...prev, "Discom Details"]);

    setDiscomDetails((prev) => {
      const last = prev[prev.length - 1] || createEmptyDiscomDetail();
      const cloned = {
        ...last,
        region: last.region || {},
        state: last.state || {},
        discom: last.discom || {},
      };
      return [...prev, cloned];
    });
  };

  const handleRemoveUser = (index) => {
    setTotalLength((prev) => prev.filter((_, i) => i !== index));
    setDiscomDetails((prev) => prev.filter((_, i) => i !== index));
  };

  const handleGetStateByRegionId = (id) => {
    dispatch(publicStateByRegionId(id));
  };
  const handleGetDiscomByStateId = (id) => {
    dispatch(publicDiscomByStateId(id));
  };

  const renderSelectInput = (index, type, list, example, heading, disabled = false) => (
    <SelectInput
      onChange={(value) =>
        handleFieldChange(
          index,
          type,
          value,
          type === "region"
            ? handleGetStateByRegionId
            : type === "state"
            ? handleGetDiscomByStateId
            : null
        )
      }
      list={list}
      value={discomDetails[index][type]}
      example={example}
      heading={`${heading}`}
      height="45px"
      error={errors[`${type}_${index}`]}
      disabled={disabled}
    />
  );

  const renderDiscomDetails = (ele, index) => (
    <div className={Styles.multiLayerContainer} key={index}>
      {/* <div className={`${Styles.alterSection} ${Styles.alterSectionOther}`}>
        {totalLength.length > 1 && (
          <div
            className={Styles.deleteSection}
            onClick={() => handleRemoveUser(index)}
          >
            <RemoveIcon style={{ fontSize: "16px" }} />
          </div>
        )}
        <div
          className={`${Styles.addSection} ${Styles.AddnewGenSection}`}
          onClick={handleAddUser}
        >
          <Add style={{ fontSize: "14px" }} />
          <span className={Styles.addNewHeading}>Add New Discom</span>
        </div>
      </div> */}

      {/* Discom Details  */}
      <div className={Styles.layer1ElementsContainer}>
        {renderSelectInput(
          index,
          "region",
          publicData?.region,
          "Select Region",
          "Region"
        )}
      </div>
      <div className={Styles.layer2ElementsContainer}>
        {renderSelectInput(
          index,
          "state",
          publicData?.stateUT,
          "Select State",
          "State"
        )}
        {renderSelectInput(
          index,
          "discom",
          publicData?.discom,
          "Select Discom",
          "Discom",
          !discomDetails[index]?.state?.id
        )}
      </div>
    </div>
  );

  return (
    <div className={Styles.elementMain}>
      <div className={Styles.displayInputSection}>
        <div className={`${Styles.conterntHeader} ${Styles.contentDiscom}`}>
          Discom Details
        </div>
        <div className={Styles.detailsInpMainContainer}>
          {totalLength.map((ele, index) => renderDiscomDetails(ele, index))}
        </div>
      </div>
      <div className={Styles.buttonSection}>
        <div className={Styles.prevBtn} onClick={() => handleProceed("prev")}>
          Back
        </div>
        <div className={Styles.nextBtn} onClick={() => handleContinue("next")}>
          Next
        </div>
      </div>
    </div>
  );
};

export default DiscomDetails;
